import { toastError } from '../../../infrastructure/hooks/useToast'
import { ACTIVES_URL } from '../../../constants/navigation.constants'
import { createSlice } from '../zustandHelpers'
import { INavigationState, INavigationActions } from './navigation.slice.interface'

export const navigationSlice = createSlice<INavigationState, INavigationActions>((set) => ({
  activeMenu: '/',
  navigationError: null,

  navigate: (pathname) => {
    try {
      if (ACTIVES_URL.includes(pathname)) {
        set({ activeMenu: pathname, navigationError: null })
      }
    } catch (error) {
      set((state) => ({ ...state, navigationError: error }))
      toastError('Navigation error')
    }
  },
  setActiveMenu: (pathname) => set({ activeMenu: pathname }),
  cleanNavigation: () => set({ activeMenu: '/', navigationError: null }),
}))
